import React, { useEffect, useState } from "react";
import { Grid, FormControl, IconButton, ListItem, ListItemText, ListItemSecondaryAction, List, Tooltip, useTheme } from "@material-ui/core";
import AddCircleIcon from '@material-ui/icons/AddCircle';
import EditIcon from '@material-ui/icons/Edit';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { panelAlcoholStyle } from "../panelAlcoholStyle";
import { useDispatch } from "react-redux";
import { listSuper, createNewSupervisor, updateSupervisor, deleteSupervisor } from "../../domain/api/SupervisorApi";
import { ROL_USER } from "../../../app/api-client/constants";


export const TablaSuper = ({ data }) => {
    const rol = localStorage.getItem(ROL_USER);
    const classes = panelAlcoholStyle();
    const [isErrRes, setIsErrRes] = useState(false);
    const [listResponse, setlistResponse] = useState([]);
    const [response, setResponse] = useState("");
    const [email, setEmail] = useState("");
    const [nombre, setNombre] = useState("");
    const [isErrResponse, setisErrResponse] = useState(false)
    const [isErrNombre, setIsErrNombre] = useState(false);
    const [isErrEmail, setIsErrEmail] = useState(false);
    
    const [messageErrC, setMessageErrC] = useState("")
    const [editSuper, setEditSuper] = useState(false)
    const [disbledAddEdit, setdisbledAddEdit] = useState(false)
    const [objectEdit, setobjectEdit] = useState({})
    const [isSucces, setIsSucces] = useState(false)
    const [messageSucces, setMessageSucces] = useState("")
    const dispatch = useDispatch();

    const handledSucces = (msj) => {
        setMessageSucces(msj)
        setIsSucces(true)
        setTimeout(() => {
            setIsSucces(false)
        }, 3000);
    }
    const theme = useTheme(); // Obtén el tema

    const primaryColor = theme.palette.primary.main;
    const handledAddResponse = (type) => {



        switch (type) {
            case "add":

                if (listResponse.length < 5) {
                    if (response !== "" && email !== "") {

                        const object = {
                            nombre: nombre,
                            celular: response,
                            evbi: data.id,
                            email: email
                        }

                        listResponse.push(
                            object
                        )

                        createNewSupervisor(dispatch, object)
                        handledSucces("Se creo correctamente el supervisor")
                        setNombre("")
                        setResponse("")
                        setEmail("")
                    } else {

                        setisErrResponse(true)
                        setIsErrEmail(true)
                        setResponse(true)
                    }
                } else {

                    setMessageErrC("Esta bascula ya cuenta con la cantidad de supervisores permitidos")
                    setIsErrRes(true)
                    setTimeout(() => {
                        setIsErrRes(false)
                    }, 3000);

                }

                break;


            case "edit":

                if (response !== "") {

                    const object = {
                        id: objectEdit.id,
                        nombre: nombre,
                        celular: response,
                        evbi: data.id,
                        email: email
                    }

                    listResponse.forEach((item, index) => {
                        if (item.id === objectEdit.id) {

                            listResponse[index] = {

                                bascula: objectEdit.evbi,
                                celular: response,
                                email: email,
                                created: objectEdit.created,
                                id: objectEdit.id,
                                nombre: nombre,
                                updated: objectEdit.updated
                            }

                        }
                    });

                    updateSupervisor(dispatch, object)
                    handledSucces(`Se edito corrrectamente el supervisor`)
                   
                    setEditSuper(false)
                    setNombre("")
                    setResponse("")
                    setEmail("")

                } else {

                    setisErrResponse(true)
                }
                break;

            default:
                break;
        }



    }


    const handleChangeResponse = (e) => {
        if (!/^([0-9]{10,10}$)/.test(e.target.value)) {
            setisErrResponse(true);
            setdisbledAddEdit(true)
            setResponse(e.target.value);
        } else {
            setisErrResponse(false);
            setdisbledAddEdit(false);
            setResponse(e.target.value);
        }
    };
    
    const handleNombre = (e) => {
        const value = e.target.value;
        if (value.trim() === "") {
            setIsErrNombre(true);
            setNombre(value);
          
        } else {
            setIsErrNombre(false);
            setNombre(value);
        }
    };
    
    const handleChangeEmail = (e) => {
        const value = e.target.value;
        if (!isValidEmail(value)) {
            setIsErrEmail(true);
            setEmail(value);
           
        } else {
            setIsErrEmail(false);
            setEmail(value);
        }
    };
    
    const isValidEmail = (email) => {
        // Esta función verifica si el correo electrónico tiene un formato válido
        // Puedes implementar tu lógica de validación de correo electrónico aquí
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };
    

   
    const getDataTable = async () => {
        const id = data.id
        const dataList = await listSuper(dispatch, id);
        try {
            setlistResponse(dataList.respuesta);
        } catch (err) {
            console.log("Ocurrio un error", err)
        }
    }

    const borrar = async (id) => {
        await deleteSupervisor(dispatch, id);
        try {
            getDataTable();
        } catch (err) {
            console.log("Ocurrio un error", err)
        }

    }


    const handledEdidResponse = (item, indice) => {
        setEditSuper(true)
        setNombre(item.nombre)
        setResponse(item.celular)
        setEmail(item.email)
        setobjectEdit(item)
    }

    useEffect(() => {
        const fetchSupervisores = async () => {
            const supervisores = await listSuper(dispatch, data.id);
            setlistResponse(supervisores.codigoRespuesta !== "CE100" ? supervisores.respuesta : [])
        };
        fetchSupervisores();
    }, [])
    const inputStyles = {
        border: `1px solid ${primaryColor}`, // Usa el color primario del tema para el borde
        color: 'black',
    };


    return (
        <>
            <Grid container spacing={3} style={{ textAlign: "left" }}>
   
                    <Grid container spacing={3} style={{ textAlign: "left" }}>
                        <Grid item xs={10} md={5} sm={10}>
                            <br></br>
                            <FormControl fullWidth variant="outlined">
                                <input
                                    placeholder="Nombre Supervisor"
                                    id="nombre"
                                    type="text"
                                    name='nombre'
                                    value={nombre}
                                    onChange={(e) => handleNombre(e)}
                                    labelWidth={130}
                                    style={inputStyles}
                                    disabled={rol === 'ROLE_USER' && !editSuper}
                                />
                            </FormControl>
                            {isErrNombre && <div style={{ color: "red", paddingTop: 10 }}>Error en el nombre</div>}
                        </Grid>
                        <Grid item xs={10} md={5} sm={10}>
                            <br></br>
                            <FormControl fullWidth variant="outlined">
                                <input
                                    placeholder="Celular Supervisor"
                                    id="respuesta"
                                    type="text"
                                    name='respuesta'
                                    value={response}
                                    onChange={(e) => handleChangeResponse(e)}
                                    labelWidth={130}
                                    style={inputStyles}
                                    disabled={rol === 'ROLE_USER' && !editSuper}
                                />
                            </FormControl>
                            {isErrResponse && <div style={{ color: "red", paddingTop: 10 }}>No se aceptan letras, la longitud son 10 caracteres</div>}
                           
                        </Grid>
                        <Grid item xs={10} md={5} sm={10}>
                            <FormControl fullWidth variant="outlined">
                                <input
                                    placeholder="Email Supervisor"
                                    id="email"
                                    type="text"
                                    name='email'
                                    value={email}
                                    onChange={(e) => handleChangeEmail(e)}
                                    labelWidth={130}
                                    style={inputStyles}
                                    disabled={rol === 'ROLE_USER' && !editSuper}
                                />
                            </FormControl>
                            {isErrEmail && <div style={{ color: "red", paddingTop: 10 }}>Email invalido</div>}
                            {isSucces && <div style={{ color: "green", textAlign: "left", paddingTop: 10 }}>{messageSucces}</div>}
                        </Grid>
                    </Grid>

    
                
                    <Grid item xs={2} md={2} sm={2} style={{ textAlign: "center" }}>
                        {editSuper ? (
                            <IconButton aria-label="add" color="primary" disabled={disbledAddEdit} onClick={() => handledAddResponse("edit")}>
                                <Tooltip title="Editar supervisor" aria-label="top-end">
                                    <EditIcon fontSize="large" />
                                </Tooltip>
                            </IconButton>
                        ) : (
                            <IconButton aria-label="add" color="primary" disabled={disbledAddEdit} onClick={() => handledAddResponse("add")}>
                                <Tooltip title="Agregar Supervisor" aria-label="top-end">
                                    <AddCircleIcon fontSize="large" color="primary" />
                                </Tooltip>
                            </IconButton>
                        )}
                    </Grid>
                
    
                <Grid item xs={12} md={12} sm={12} style={{ paddingBottom: 20 }}>
                    <div className={classes.titleList}><b>Lista de supervisores</b></div>
                    <List className={classes.rootList}>
                        {listResponse.map((item, index) => {
                            const labelId = `response-${index}`;
    
                            return (
                                <ListItem key={index} role={undefined} dense button >
                                    <ListItemText
                                        style={{
                                            color: primaryColor,
                                            maxWidth: '450px', // Establece el ancho máximo deseado
                                            height: 'auto' // Establece la altura automática para permitir varias líneas de texto
                                        }}
                                        id={labelId}
                                        primary={`Nombre: ${item.nombre === null ? "-" : item.nombre} : Celular: ${item.celular} : Email: ${item.email === null ? "-" : item.email}`}
                                    />
    
                                    <ListItemSecondaryAction>
                                        <IconButton edge="end" aria-label="comments" onClick={() => handledEdidResponse(item, index)} >
                                            <Tooltip title="Editar supervisores" aria-label="top-end">
                                                <EditIcon color="primary" />
                                            </Tooltip>
                                        </IconButton>
                                        {rol !== 'ROLE_USER' && (
                                            <IconButton edge="end" aria-label="comments" onClick={() => borrar(item.id)} >
                                                <Tooltip title="Eliminar supervisor" aria-label="top-end">
                                                    <DeleteForeverIcon color="primary" />
                                                </Tooltip>
                                            </IconButton>
                                        )}
                                    </ListItemSecondaryAction>
                                </ListItem>
                            );
                        })}
                    </List>
                </Grid>
            </Grid>
            {isErrRes && <div style={{ color: "red", textAlign: "center", paddingTop: 10 }}>{messageErrC}</div>}
        </>
    );
}
